/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://sy5r6puueraf3gty6ujp5iajmi.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-c3tlmtun7vcz5e2t7mcfizxma4",
    "aws_cognito_identity_pool_id": "ap-south-1:c9a49912-3929-4f0a-9d37-2bd62b65488c",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_MEsK6tmWr",
    "aws_user_pools_web_client_id": "2kkncp15pgn0add44ndrmvp6iv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "getscreenedstoragebucketf24ed-devget",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
